import AjaxService from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const create = (chat_id, zoomParams) => {
    return AjaxService({
        method: 'post',
        url: `zoom/create`,
        data: {
            chat_id,
            ...zoomParams
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const getSignature = (meeting_id, role) => {
    return AjaxService({
        method: 'get',
        url: `zoom/signature`,
        params: {
            meeting_id,
            role
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}
